module.exports = __webpack_public_path__ + "static/img/beans.f09cc656.png";